"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trontano": {
    "8ef76478": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "casello": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0943a51": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8090e81d": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6709560": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "cocco": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1bd469c": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "grignaschi": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9551280": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "marone": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25551902": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "melezzo": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc57356c": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "pigaia": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7489cc52": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "porcelli": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2767fa88": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "quara": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be3192a8": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "ventriago": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "14274a39": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "skipSearch": false
    }],
    "verigo": [{
      "hkey": "b68d59e0",
      "slug": "trontano",
      "name": "Trontano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;